import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
    hasMore: false,
  },
  permissionStatus: 'default', // 'default', 'granted', 'denied'
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload.data || [];
      state.pagination = action.payload.pagination || state.pagination;
      state.unreadCount = action.payload.unreadCount ?? state.unreadCount;
      state.loading = false;
      state.error = null;
    },
    appendNotifications: (state, action) => {
      // For infinite scroll / load more
      const newNotifications = action.payload.data || [];
      state.notifications = [...state.notifications, ...newNotifications];
      state.pagination = action.payload.pagination || state.pagination;
      state.loading = false;
    },
    addNotification: (state, action) => {
      // Add a new real-time notification at the top
      state.notifications.unshift(action.payload);
      state.unreadCount += 1;
      state.pagination.total += 1;
    },
    markRead: (state, action) => {
      const id = action.payload;
      const notification = state.notifications.find(n => n._id === id);
      if (notification && !notification.isRead) {
        notification.isRead = true;
        notification.readAt = new Date().toISOString();
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllRead: (state) => {
      state.notifications.forEach(n => {
        n.isRead = true;
        n.readAt = new Date().toISOString();
      });
      state.unreadCount = 0;
    },
    removeNotification: (state, action) => {
      const id = action.payload;
      const index = state.notifications.findIndex(n => n._id === id);
      if (index !== -1) {
        if (!state.notifications[index].isRead) {
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
        state.notifications.splice(index, 1);
        state.pagination.total -= 1;
      }
    },
    clearAll: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
      state.pagination = { ...initialState.pagination };
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setPermissionStatus: (state, action) => {
      state.permissionStatus = action.payload;
    },
    resetNotifications: () => initialState,
  },
});

export const {
  setNotifications,
  appendNotifications,
  addNotification,
  markRead,
  markAllRead,
  removeNotification,
  clearAll,
  setUnreadCount,
  setLoading,
  setError,
  setPermissionStatus,
  resetNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
